import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import CommentAction from "./CommentAction";
import CommentInteraction from "./CommentInteraction";
import CommentReplyInteraction from "./CommentReplyInteraction";
import CommentReplyAction from "./CommentReplyAction";
import EditComment from "./EditComment";
import axios from "../../API/axios";
import { people } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
const Comment = ({
  isOwnedPost,
  item,
  postId,
  postList,
  AllPostList,
  setPostList,
  emojiList,
  setSinglePostId,
  setInitialSlideIndex,
  setImageArray,
  openModal,
  setSinglePostContent,
  singlepostCommentList,
  setSinglePostCommentList,
  AllPostComments,
  updateLikeCount,
  updateCommentLike,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  console.log("setPostList", item);
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const localeMap = {
      en: "en",
      ar: "ar",
      hi: "hi",
    };

const locale = localeMap[language] || "en";
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  // State for tracking which comment is being edited
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [editingReplyId, setEditingReplyId] = useState(null); // State for reply editing
  const [editedDynamicValue, setEditedDynamicValue] = useState([]);
  // const [commentsState, setCommentsState] = useState(
  //   item?.postComments.map((comment) => ({
  //     ...comment,
  //     editedComment: comment.comment, // Store edited comment per comment
  //     commentsReplies: comment.commentsReplies?.map((reply) => ({
  //       ...reply,
  //       editedReply: reply.reply, // Store edited reply per reply
  //     })),
  //   }))
  // );

  const [commentsState, setCommentsState] = useState([]);
  console.log("commentsState111===>", item);

  // useEffect to initialize commentsState when singlepostList is available or updated
  useEffect(() => {
    if (item?.postInfo?.comments?.length > 0) {
      setCommentsState(
        item?.postInfo?.comments.map((comment) => ({
          ...comment,
          editedComment: comment?.comment,
          commentsReplies: comment?.commentsReplies?.map((reply) => ({
            ...reply,
            editedReply: reply?.reply,
          })),
        }))
      );
    } else {
      setCommentsState([]);
    }
  }, [item]);


  const updateComment = (pstCmntId, newComment) => {
    const updatedPostList = postList?.map((post) => {
      if (post?.id === postId) {
        return {
          ...post,
          postComments: post?.comments?.map((comment) => {
            if (comment?.pstCmntId === pstCmntId) {
              return { ...comment, comment: newComment };
            }
            return comment;
          }),
        };
      }
      return post;
    });
    setPostList(updatedPostList);
  };

  const updateCommentReply = (pstCmntRplyId, newComment) => {
    const updatedPostList = postList?.map((post) => {
      console.log("post?.id", post?.id);
      if (post?.id === postId) {
        return {
          ...post,
          postComments: post?.comments?.map((comment) => {
            if (comment?.pstCmntRplyId === pstCmntRplyId) {
              return { ...comment, comment: newComment };
            }
            return comment;
          }),
        };
      }
      return post;
    });
    setPostList(updatedPostList);
  };

  const handleEdit = (commentId) => {
    setEditingCommentId(commentId); // Set the comment to be edited
  };

  const handleSave = async (commentId, updatedComment, updatedDynVals) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );
    console.log("commentToEdit", commentToEdit);
    const commentText = updatedComment ?? commentToEdit?.editedComment;
    const dynVals = updatedDynVals ?? editedDynamicValue;
    //DS-New Logic
    const filterEditedDynamicValue = filterArrayByString(
      commentText,
      dynVals || []
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

      pstCmntId: commentId,
      comment: commentText, // Use the updated comment
      // dynamicValues: editedDynamicValue,
      dynamicValues: filterEditedDynamicValue,
    };
    try {
      const res = await axios.post(
        `PostAction/UpdateCommentPost`,
        responseData
      );
      updateComment(commentId, commentText); // Update comment in UI
      setEditingCommentId(null); // Exit edit mode
      setToastMessage(res.data.message);
      setShowToast(true);

      AllPostList();
    } catch (error) {
      console.error("Error saving comment:", error);
      setErrorToastMessage(error.message);
      setShowErrorToast(true);
    }
  };

  //DS-New logic add to filter out unwanted dVNo object
  const filterArrayByString = (inputString, dataArray) => {
    // Extract allowed dVno values from the string
    const allowedDVnos = Array.from(
      inputString.matchAll(/\{(\d+)\}/g),
      (match) => Number(match[1])
    );
    // Filter the array based on dVno presence in allowedDVnos
    return dataArray.filter((item) => allowedDVnos.includes(item.dVno));
  };

  const handleCommentChange = (commentId, newComment) => {
    console.log("OnClick function==>", commentId, newComment);
    if (newComment !== "" || newComment !== undefined) {
      setCommentsState(
        commentsState.map((comment) =>
          comment.pstCmntId === commentId
            ? {
              ...comment,
              editedComment: newComment,
              dynamicValues: editedDynamicValue,
            }
            : comment
        )
      );
    }
  };

  const handleReplyEdit = (replyId) => {
    setEditingReplyId(replyId);
  };

  const handleReplySave = async (commentId, replyId, updatedReply) => {
    const commentToEdit = commentsState.find(
      (comment) => comment.pstCmntId === commentId
    );
    const replyToEdit = commentToEdit.commentsReplies.find(
      (reply) => reply.pstCmntRplyId === replyId
    );
    const replyText = updatedReply ?? replyToEdit?.editedReply;
    // console.log("commentToEdit2222222222", replyToEdit);
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntRplyId: replyId,
      reply: replyText, // Use the updated reply
      langKey: language === "en" ? "" : language,

    };

    try {
      const res = await axios.post(`PostAction/UpdateCommentReply`, responseData);
      updateCommentReply(replyId, replyText); // Update comment in UI
      setToastMessage(res.data.message);
      setShowToast(true);
      setEditingReplyId(null); // Exit reply edit mode
    } catch (error) {
      console.error("Error saving reply:", error);
    }
  };

  // console.log("commentsState", commentsState);

  const handleReplyChange = (commentId, replyId, newReply) => {
    console.log("commentId", newReply);

    setCommentsState(
      commentsState?.map((comment) =>
        comment.pstCmntId === commentId
          ? {
            ...comment,
            commentsReplies: comment?.commentsReplies?.map((reply) =>
              reply.pstCmntRplyId === replyId
                ? { ...reply, editedReply: newReply }
                : reply
            ),
          }
          : comment
      )
    );
  };

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const stripLeadingHashes = (str) => {
    return str.replace(/^#+/, "");
  };

  // const replaceDynamicValues = (content, dynamicValues) => {
  //   if (!content || !dynamicValues) return content;
  //   dynamicValues.forEach((item) => {
  //     const placeholder = `{${item.dVno}}`;
  //     const replacement =
  //       item.type === "UserMention"
  //         ? `<a href="/user/${
  //             item.entityID || item.entity
  //           }" class="user-mention">@${item.displayName || item.display} </a>`
  //         : item.type === "Hashtag"
  //         ? `<a href="/hashtag/${
  //             item.displayName || item.display
  //           }" class="hashtag">#${item.displayName || item.display}</a>`
  //         : item.displayName;
  //     content = content.replaceAll(placeholder, replacement);
  //   });
  //   return content;
  // };

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;

      const cleanDisplay = stripLeadingHashes(item.displayName || item.display);

      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID || item.entity
          }" class="user-mention">@${item.displayName || item.display} </a>`
          : item.type === "CompanyMention"
            ? `<a href="/Company/${item.entityID || item.entity
            }" class="user-mention">@${item.displayName || item.display} </a>`
            : item.type === "Hashtag"
              ? `<a href="/hashtag/${cleanDisplay}" class="hashtag">#${item.displayName || item.display
              }</a>`
              : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  const commentedPost = (item) => {
    const formattedContent = linkifyContent(
      addTargetBlankToAnchors(
        replaceDynamicValues(item?.editedComment, item?.dynamicValues)
      )
    );
    return formattedContent;
  };

  // const parseMentionsAndHashtags = (text) => {
  //   if (!text) return "";

  //   let parsedText = text.replace(
  //     /(^|\s)@(\w+)/g,
  //     '$1<a href="/profile/$2" class="mention-link">@$2</a>'
  //   );

  //   parsedText = parsedText.replace(
  //     /(^|\s)#(\w+)/g,
  //     '$1<a href="/hashtag/$2" class="hashtag-link">#$2</a>'
  //   );

  //   return parsedText;
  // };


  //   const commentedPost = (item) => {
  //   const withDynamicValues = replaceDynamicValues(
  //     item?.editedComment,
  //     item?.dynamicValues
  //   );

  //   const withMentionsAndTags = parseMentionsAndHashtags(withDynamicValues);

  //   const withAnchors = addTargetBlankToAnchors(withMentionsAndTags);

  //   const formattedContent = linkifyContent(withAnchors);

  //   return formattedContent;
  // };


  return (
    <>
      <div className="comment-section mt-1">
        {commentsState &&
          commentsState.slice(0, 3).map((commentItem, index) => {
            // console.log("commentItemcommentItem", commentItem.creationTime);
            const now = moment.utc().local();
            const itemTime = moment.utc(commentItem?.creationTime).local();

            const diffSeconds = now.diff(itemTime, "seconds");
            const diffMinutes = now.diff(itemTime, "minutes");
            const diffHours = now.diff(itemTime, "hours");
            const diffDays = now.diff(itemTime, "days");
            const diffMonths = now.diff(itemTime, "months", true);
            const diffYears = now.diff(itemTime, "years", true);

            let result = "";

            if (diffSeconds < 60) {
              result = t("Notifications.Just Now");
            } else if (diffMinutes < 60) {
              result =
                diffMinutes === 1
                  ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                  : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
            } else if (diffHours < 24) {
              result =
                diffHours === 1
                  ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                  : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
            } else if (diffDays < 30) {
              result =
                diffDays === 1
                  ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                  : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
            } else if (diffMonths < 12) {
              const displayMonth =
                diffMonths >= 0.75 && diffMonths < 1.25
                  ? 1
                  : Math.round(diffMonths * 2) / 2;
              result =
                displayMonth === 1
                  ? `${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                  : `${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
            } else {
              const displayYear =
                diffYears >= 0.75 && diffYears < 1.25
                  ? 1
                  : Math.round(diffYears * 2) / 2;
              result =
                displayYear === 1
                  ? `${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                  : `${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
            }

            return (
              <div
                key={index}
                className="rounded pe-1"
                style={{
                  width: "100%",
                  marginBottom: "5px",
                }}
              >
                <div className="mainComment  d-flex mb-1 p-1  d-flex">
                  <Link to={`/User/${commentItem.useruid}`}>
                    <div>
                      <img
                        src={commentItem?.userAvatar || people.DefaultProfile}
                        width={30}
                        height={30}
                        alt=""
                        style={{
                          borderRadius: "50px",
                          border: "1px solid black",
                          // marginTop:'10px',
                        }}
                        onError={handleProfileImageError}
                      />
                    </div>
                  </Link>

                  <div className="w-100">
                    <div className="userCommentdetail ms-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className="f-12 fw-bold mb-0">
                          {commentItem?.userName}
                        </h4>
                        <div className="d-flex align-items-center gap-2">
                         {language === "ar" ? (
                            <Tooltip title={moment
                                                  .utc(commentItem?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a" )} arrow>
                                              <span
                                                  className="f-7  comment-dateSection"
                                                  style={{ fontSize: "10px" }}
                                                >
                                                {moment
                                                  .utc(commentItem?.creationTime)
                                                  .locale(locale)
                                                  .local()
                                                  .format( "D MMMM YYYY [الساعة] h:mm a" )}
                                              </span>
                                           </Tooltip>
                                            
                                        ) : (
                                            <Tooltip title={moment
                                                  .utc(commentItem?.creationTime)
                                                  .local()
                                                  .format(language === "en"
                                                      ? "D MMMM YYYY [at] h:mm a"
                                                      :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                              <span
                                                  className="f-7  comment-dateSection"
                                                  style={{ fontSize: "10px" }}
                                                >
                                                  {result}
                                                </span>
                                           </Tooltip>    

                                        )}
                                               {/* <Tooltip title={moment
                                                    .utc(commentItem?.creationTime)
                                                    .local()
                                                    .format("DD MMMM YYYY [at] h:mm a")} arrow>
                                               <span
                                                  className="f-7  comment-dateSection"
                                                  style={{ fontSize: "10px" }}
                                                >
                                                  {result}
                                                  {moment(commentItem?.creationTime).local().fromNow()}  
                                                </span>
                                          </Tooltip>                         */}
                          <CommentInteraction
                            isOwnedPost={isOwnedPost}
                            item={commentItem}
                            handleSave={() => handleSave(commentItem.pstCmntId)}
                            handleEdit={() => handleEdit(commentItem.pstCmntId)}
                            isEditing={
                              editingCommentId === commentItem.pstCmntId
                            }
                            setPostList={setPostList}
                            postList={postList}
                            AllPostList={AllPostList}
                            postId={postId}
                          />
                        </div>
                      </div>
                      <div className="commentText">
                        {editingCommentId === commentItem.pstCmntId ? (
                          <EditComment
                            isEditing={true}
                            editedComment={commentItem.editedComment} // Pass specific edited comment
                            handleCommentChange={(newComment) =>
                              handleCommentChange(
                                commentItem.pstCmntId,
                                newComment
                              )
                            }
                            handleSave={(updatedComment, updatedDynVals) =>
                              handleSave(
                                commentItem.pstCmntId,
                                updatedComment,
                                updatedDynVals
                              )
                            }
                            setIsEditing={() => setEditingCommentId(null)}
                            dynamicValues={commentItem?.dynamicValues}
                            setEditedDynamicValue={setEditedDynamicValue}
                          />
                        ) : (
                          <>
                            {/* <p className="f-14">{commentItem.editedComment}</p> */}
                            {/* // Render updated comment */}
                            <div
                              className="postContentDiv"
                              dangerouslySetInnerHTML={{
                                __html: commentedPost(commentItem),
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <CommentAction
                      item={commentItem}
                      emojiList={emojiList}
                      postId={postId}
                      setPostList={setPostList}
                      AllPostList={AllPostList}
                      updateLikeCount={updateLikeCount}
                      updateCommentLike={updateCommentLike}
                    />
                  </div>
                </div>

                {/* Comment Replies */}
                {commentItem?.commentsReplies &&
                  commentItem?.commentsReplies
                    .slice(0, 3)
                    .map((reply, replyIndex) => {
                      console.log("replyyy", reply);
                      
                      const now = moment.utc().local();
                    const itemTime = moment.utc(reply?.creationTime).local();

                    const diffSeconds = now.diff(itemTime, "seconds");
                    const diffMinutes = now.diff(itemTime, "minutes");
                    const diffHours = now.diff(itemTime, "hours");
                    const diffDays = now.diff(itemTime, "days");

                    const diffMonths = now.diff(itemTime, "months", true);
                    const diffYears = now.diff(itemTime, "years", true);

                    let result = "";

                    /* JUST NOW */
                    if (diffSeconds < 60) {
                      result = t("Notifications.Just Now");
                    }

                    /* MINUTES */
                    else if (diffMinutes < 60) {
                      result =
                        diffMinutes === 1
                          ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                          : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                    }

                    /* HOURS */
                    else if (diffHours < 24) {
                      result =
                        diffHours === 1
                          ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                          : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                    }

                    /* DAYS */
                    else if (diffDays < 30) {
                      result =
                        diffDays === 1
                          ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                          : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                    }

                    /* MONTHS */
                    else if (diffMonths < 12) {
                      const displayMonth =
                        diffMonths >= 0.75 && diffMonths < 1.25
                          ? 1
                          : Math.round(diffMonths * 2) / 2;

                      result =
                        displayMonth === 1
                          ? `${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                          : `${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                    }

                    /* YEARS */
                    else {
                      const displayYear =
                        diffYears >= 0.75 && diffYears < 1.25
                          ? 1
                          : Math.round(diffYears * 2) / 2;

                      result =
                        displayYear === 1
                          ? `${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                          : `${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                    }
                      return (
                      <div
                        className="mainComment d-flex mb-1 ms-md-5 ms-4 rounded d-flex p-1"
                        style={{
                          maxWidth: "800px",
                        }}
                        key={replyIndex}
                      >
                        {/* {console.log("commentreply2222", commentItem?.commentsReplies.creationTime)} */}
                        <div className="mt-1">
                          <img
                            src={reply?.userAvatar || people.DefaultProfile}
                            width={30}
                            height={30}
                            alt=""
                            className="ms-1"
                            style={{
                              borderRadius: "50px",
                              border: "1px solid black",
                            }}
                            onError={handleProfileImageError}
                          />
                        </div>
                        <div className="w-100 mt-1">
                          <div className="userCommentdetail ms-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <h4 className="f-12 fw-bold mb-0">
                                {reply?.userName}
                              </h4>
                              <div className="d-flex align-items-center gap-2">
                                
                                          {/* <Tooltip title={moment
                                                    .utc(commentItem?.commentsReplies.creationTime)
                                                    .local()
                                                    .format("DD MMMM YYYY [at] h:mm a")} arrow>
                                               <span
                                                  className="f-7  comment-dateSection"
                                                  style={{ fontSize: "10px" }}
                                                >
                                                  {result}
                                               {moment(commentItem?.commentsReplies.creationTime).fromNow()}  
                                                </span>
                                          </Tooltip>     */}
                                          {language === "ar" ? (
                                             <Tooltip title={moment
                                                    .utc(reply.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format( "D MMMM YYYY [الساعة] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {moment
                                                    .utc(reply.creationTime)
                                                    .locale(locale)
                                                    .local()
                                                    .format("D MMMM YYYY [الساعة] h:mm a" )}
                                                </p>
                                             </Tooltip>
                                                 
                                          ) : (
                                               <Tooltip title={moment
                                                    .utc(reply.creationTime)
                                                    .local()
                                                    .format(language === "en"
                                                        ? "D MMMM YYYY [at] h:mm a"
                                                        :  "D MMMM YYYY [को] h:mm a" )} arrow>
                                                <p className="f-10 label"> 
                                                  {result}
                                                  {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                                </p>
                                             </Tooltip> 
  
                                          )}                                                                     
                                <CommentReplyInteraction
                                  isOwnedPost={isOwnedPost}
                                  item={reply}
                                  handleReplySave={() =>
                                    handleReplySave(
                                      commentItem.pstCmntId,
                                      reply.pstCmntRplyId
                                    )
                                  }
                                  handleReplyEdit={() =>
                                    handleReplyEdit(reply.pstCmntRplyId)
                                  }
                                  isEditing={
                                    editingReplyId === reply.pstCmntRplyId
                                  }
                                  setPostList={setPostList}
                                  postList={postList}
                                  postId={postId}
                                  commentId={commentItem.pstCmntId}
                                />
                              </div>
                            </div>
                            <div className="commentText">
                              {editingReplyId === reply.pstCmntRplyId ? (
                                <EditComment
                                  isEditing={true}
                                  editedComment={reply.editedReply} // Pass specific edited reply
                                  handleCommentChange={(newReply) =>
                                    handleReplyChange(
                                      commentItem.pstCmntId,
                                      reply.pstCmntRplyId,
                                      newReply
                                    )
                                  }
                                  handleSave={(updatedReply) =>
                                    handleReplySave(
                                      commentItem.pstCmntId,
                                      reply.pstCmntRplyId,
                                      updatedReply
                                    )
                                  }
                                  setIsEditing={() => setEditingReplyId(null)}
                                  dynamicValues={reply?.dynamicValues}
                                  setEditedDynamicValue={setEditedDynamicValue}
                                />
                              ) : (
                                <p className="">{reply.editedReply}</p>
                                // Render updated reply
                              )}
                            </div>
                          </div>
                          <CommentReplyAction
                            item={reply}
                            emojiList={emojiList}
                            setPostList={setPostList}
                            postId={postId}
                            AllPostList={AllPostList}
                          />
                        </div>
                      </div>
                      )
          }
                    )}

                {/* View all btn....................  */}
                {commentItem?.commentsReplies?.length > 2 && (
                  <div className="text-end  mb-2">
                    <button
                      style={{ textDecoration: "none" }}
                      className="btn btn-link f-12 p-0"
                      onClick={() => {
                        setInitialSlideIndex(1);
                        setImageArray(item?.postInfo?.mediaFilesList);
                        let imageData = item?.postInfo?.mediaFilesList?.map(
                          (file) => file.mediaName
                        );
                        openModal(imageData, 1);
                        setSinglePostContent(item);
                        setSinglePostId(item?.postInfo?.postId);
                      }}
                    >
                    {t("Newsfeed.View All")}
                    
                    </button>
                  </div>
                )}
              </div>
            );
          })}

        {/* View all comments btn ...............  */}
        {commentsState.length > 2 && (
          <div className="text-center mt-1">
            <button
              style={{ textDecoration: "none" }}
              className="btn btn-link f-12 p-0"
              onClick={() => {
                setInitialSlideIndex(1);
                setImageArray(item?.postInfo?.mediaFilesList);
                let imageData = item?.postInfo?.mediaFilesList?.map(
                  (file) => file.mediaName
                );
                openModal(imageData, 1);
                setSinglePostContent(item);
                setSinglePostId(item?.postInfo?.postId);
              }}
            >
             {t("Newsfeed.View all comments")}
            </button>
          </div>
        )}
      </div>

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />
      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};
export default Comment;

//Review comment
// 1. while entering space then submit it failing.
// 2. @ add after adding new comment is failing.
